<h2 matCardTitle style="display: flex; flex-direction: row; align-items: center;">
  Initial Ticket Description
  <button mat-icon-button [matMenuTriggerFor]="intialTicketDescriptionMenu" [disabled]="pTicketClosed() || canUpdate">
    <mat-icon>more_vert</mat-icon>
  </button>
</h2>
<div style="margin-bottom: 20px;">{{pTicket.pct_initialdescription}}</div>

<div *ngFor="let item of pDescriptions.slice().reverse()">
  <mat-list class="message" *ngIf="item.pde_type == 'Solution'">
    <mat-list-item [ngClass]="[item.pde_type, item.isMorphing ? 'morphing' : '']" class="list-item">
      <div style="display: flex; align-items: center;">
        <p class="clock">{{ formatDateTime(item.createdAt) }} {{ item.pde_author}}</p>
        <button mat-icon-button [disabled]="pTicketClosed() || canUpdate" [matMenuTriggerFor]="menu"
          [matMenuTriggerData]="{description : item}" (click)="setSelectedDescription(item)" class="menu-button">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <p>{{ item.pde_description }}</p>
      <div *ngIf="item.files.length > 0"
        style="display: flex; flex-direction: row; align-items: end; justify-content: end; width: 100%; flex-wrap: wrap-reverse; ">
        <div *ngFor="let file of item.files">
          <div>

            <button mat-icon-button [matTooltip]="file.file.pfi_filename.split('/').pop()"
              [matMenuTriggerFor]="fileMenu" [matMenuTriggerData]="{file : file.file, pDescription: item}">
              <mat-icon *ngIf="file.file.pfi_type.includes('image')">image</mat-icon>
              <mat-icon *ngIf="file.file.pfi_type.includes('pdf')">picture_as_pdf</mat-icon>
              <mat-icon *ngIf="!file.file.pfi_type.includes('image') && !file.file.pfi_type.includes('pdf')">
                insert_drive_file
              </mat-icon>
            </button>
            <p>{{file.file.name}}</p>
          </div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>



<h2 matCardTitle>
  Communication History
</h2>


<div *ngFor="let item of pDescriptions.slice().reverse()">
  <mat-list class="message">
    <mat-list-item [ngClass]="[item.pde_type, item.isMorphing ? 'morphing' : '']" class="list-item">
      <div style="display: flex; align-items: center;">
        <p class="clock">{{ formatDateTime(item.createdAt) }} {{ item.pde_author}}</p>
        <button mat-icon-button [disabled]="pTicketClosed() || canUpdate" [matMenuTriggerFor]="menu"
          [matMenuTriggerData]="{description : item}" (click)="setSelectedDescription(item)" class="menu-button">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
      <p>{{ item.pde_description }}</p>
      <div *ngIf="item.files.length > 0"
        style="display: flex; flex-direction: row; align-items: end; justify-content: end; width: 100%; flex-wrap: wrap-reverse; ">
        <div *ngFor="let file of item.files">
          <div>

            <button mat-icon-button [matTooltip]="file.file.pfi_filename.split('/').pop()"
              [matMenuTriggerFor]="fileMenu" [matMenuTriggerData]="{file : file.file, pDescription: item}">
              <mat-icon *ngIf="file.file.pfi_type.includes('image')">image</mat-icon>
              <mat-icon *ngIf="file.file.pfi_type.includes('pdf')">picture_as_pdf</mat-icon>
              <mat-icon *ngIf="!file.file.pfi_type.includes('image') && !file.file.pfi_type.includes('pdf')">
                insert_drive_file
              </mat-icon>
            </button>
            <p>{{file.file.name}}</p>
          </div>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>





<mat-menu #fileMenu="matMenu">
  <ng-template matMenuContent let-file="file" let-description="pDescription">
    <button mat-menu-item (click)="openFile(file)">Download<mat-icon>save_alt</mat-icon></button>
    <button mat-menu-item (click)="deleteFile(file, description)"
      *ngIf="pTicket.pct_status == 'open'">Delete<mat-icon>delete</mat-icon></button>
  </ng-template>
</mat-menu>







<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-description="description">
    <button mat-menu-item (click)="onUpdateDescriptionText(description)">
      Edit<mat-icon>edit</mat-icon>
    </button>
    <button mat-menu-item [matMenuTriggerFor]="communicatorType" *ngIf="description.pde_type !== 'ChatBot'">
      Type<mat-icon>compare_arrows</mat-icon>
    </button>
    <button mat-menu-item (click)="onUpdateDescription({pde_type : 'Solution'})"
      *ngIf="description.pde_type !== 'ChatBot'">Mark as solution<mat-icon>check_circle_outline</mat-icon></button>
    <button mat-menu-item (click)="onUploadFile(description)">Add Files<mat-icon>file_copy</mat-icon></button>
    <button mat-menu-item (click)="onDeleteDescription(description)">
      Delete<mat-icon>delete</mat-icon>
    </button>
  </ng-template>
</mat-menu>

<mat-menu #communicatorType="matMenu">
  <button mat-menu-item (click)="onUpdateDescription({pde_type : 'Support'})">Support
    <mat-icon>keyboard_arrow_left</mat-icon></button>
  <button mat-menu-item (click)="onUpdateDescription({pde_type : 'User'})">User
    <mat-icon>keyboard_arrow_right</mat-icon></button>
</mat-menu>

<mat-menu #intialTicketDescriptionMenu="matMenu">
  <button mat-menu-item (click)="onEditInitialDescription($event)">Edit<mat-icon>edit</mat-icon></button>


</mat-menu>